// extracted by mini-css-extract-plugin
module.exports = {"textalign":"quiz_modal_textalign__2Vpsn","labels":"quiz_modal_labels__3Llfz","headlabel":"quiz_modal_headlabel__6Vc7I","second_container":"quiz_modal_second_container__19_9w"};